<template>
  <transition name="element-modal">
    <div class="element-modal" v-if="element && element.value == 1" :style="`z-index: ${zIndex}`">
      <div class="container" :style="`width: ${width}`">
        <!--<div class="close" @click="closeModal">×</div>-->
        <slot />
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: [ "elementId"],
  computed: {
    element(){
      return this.$store.getters[ "elementModal/GET_ITEM" ]({ elementId: this.elementId });
    },
    width() {
      return this.elementId === 'globalLifeEstimateResult' ? '600px' : '1000px';
    },
    zIndex() {
      return this.elementId === 'globallifeEstimate' ? 1000 : 2000;
    }
  },
  created(){
    if( !this.$store.state.elementModal ){
      this.$store.registerModule( "elementModal", {
        namespaced: true,
        state: {
          items: {}
        },
        getters: {
          GET_ITEM: state => payload => {
            return state.items[ payload.elementId ];
          }
        },
        mutations: {
          SET_ITEM: ( state, payload ) => {
            this.$set( state.items, payload.elementId, { ...payload, value: 1 });
          },
          UNSET_ITEM: ( state, payload ) => {
            this.$set( state.items, payload.elementId );
          },
          CLEAR_ITEMS: ( state, payload ) => {
            this.$set( state, "items", {});
          },
          SET_VALUE: ( state, payload ) => {
            state.items[ payload.elementId ].value = payload.value;
          },
        },
      });
    };
  },
  methods: {
    closeModal(){
      this.$store.commit( "elementModal/SET_VALUE", { elementId: this.elementId, value: 0 })
    }
  }
}
</script>
